






import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { TReturnPage, TReturnForm, TReturnSearch } from '@/types/views/school';
import { getRebackCoursePackagePage } from '@/api/school';
@Component({
  components: {
    Search: () => import('./components/search.vue'),
    List: () => import('./components/list.vue')
  }
})
export default class Return extends Vue {
  private returnPage: TReturnPage = {};
  private returnSearch: TReturnSearch = {
    pageSize: 20,
    currentPage: 1
  };
  private activated() {
    this.getReturnData()
  }
  private handleReturnSearch(opts: TReturnForm) {
    this.returnSearch = { ...this.returnSearch, ...opts };
  }
  private async getReturnData() {
    try {
      let res: any = await getRebackCoursePackagePage(this.returnSearch);
      this.returnPage = res;
    } catch (e) {
      this.$message.error(e);
    }
  }
}
